import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';

interface CustomLineChartProps {
  data: {
    name: string;
    pv: number;
    amt: number;
  }[];
}

interface CustomTooltipProps {
  active?: boolean;
  payload?: {
    value: number;
    payload: {
      name: string;
      value: number;
    };
  }[];
}

const hasValidData = (data: { name: string; pv: number; amt: number }[]) => data.length > 0 && data.some((item) => item.pv !== null && item.pv !== undefined);

const CustomLineChart = ({ data }: CustomLineChartProps) => {
  const CustomTooltip = ({ active, payload }: CustomTooltipProps) => {
    if (active && payload && payload.length) {
      return (
                      <div className="bg-surface-base p-2 rounded-md shadow-md">
          <p className="label font-medium text-text-primary">{payload[0].payload.name}</p>
          <p className="text-sm text-text-secondary">{payload[0].value}</p>
        </div>
      );
    }
    return null;
  };
  return (
    <ResponsiveContainer width="100%" height={300}>
      {hasValidData(data) ? <LineChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={'rgb(var(--color-text-secondary))'} />
        <XAxis dataKey="name" stroke={'rgb(var(--color-text-secondary))'} tick={{ fill: 'rgb(var(--color-text-secondary))' }} />
        <YAxis stroke={'rgb(var(--color-text-secondary))'} tick={{ fill: 'rgb(var(--color-text-secondary))' }} />
        <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: 'rgb(var(--color-surface-secondary))', opacity: 0.7 }}
          />
        <Line type="monotone" dataKey="pv" stroke={'rgb(var(--color-primary-500))'} dot={false} strokeWidth={2} />
      </LineChart>
        : <div className='flex flex-col items-center justify-center h-full'>
          <p className='text-text-secondary'>No hay datos</p>
        </div>}
    </ResponsiveContainer>
  );
};

export default CustomLineChart;
